import { get, post, put } from '../utils/api';

/**
 * 提现服务
 */
export const withdrawService = {
  // 申请提现
  createWithdraw: async (walletAddress, amount, assetType = 'USDT') => {
    const response = await post('/withdraw', {
      walletAddress,
      amount,
      assetType,
    });
    return response.data;
  },

  // 获取提现记录列表
  getWithdrawList: async (page = 1, size = 10, keyword = '', status = null) => {
    const params = { page, size, keyword };
    if (status !== null) params.status = status;
    const response = await get('/withdraw', params);
    return response.data;
  },

  // 获取用户提现记录
  getUserWithdraws: async (walletAddress, page = 1, size = 10) => {
    const response = await get(`/withdraw/user/${walletAddress}`, { page, size });
    return response.data;
  },
};

